import React, { useState, useEffect } from 'react';
import Select from 'react-select';

import { getChartAnswers } from '../../api';

const SelectAnswer = props => {
    
    const [defaultValue, setDefaulValue] = useState({});
    const [answerList, setAnswerList] = useState([]);

    useEffect(() => {
        getLoadData(props.chart, props.indicator);
    }, []);

    useEffect(() => {
        getLoadData(props.chart, props.indicator);
    }, [props.chart]);

    const getLoadData = (chart, indicator) => {
        getChartAnswers(chart, indicator)
        .then((res) => {
            const data = res.resultset[0];
            if (data)
            {
                setDefaulValue({
                    label: data.text,
                    value: data.id
                });

                handleDefaultAnswerChange(data.id, data.text);
            }

            setAnswerList(res.resultset);
        })
    }

    const handleDefaultAnswerChange = (answer,label) => {
        props.handleAnswerChange(answer, label);
    }

    const handleAnswerChange = (e) => {
        setDefaulValue({
            label: e.label,
            value: e.value
        });
        props.handleAnswerChange(e.value, e.label);
    }

    return(
        <Select
            onChange={(e) => handleAnswerChange(e)}
            value={ defaultValue }
            className="select-component"
            options={ answerList.map(item=>( { label: item.text, value: item.id } ) ) }
        />
    )
}

export default SelectAnswer;